var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDjango(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    fill: "none",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 75,
    fill: "#092D1F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M107.5 42.5h-5.417a5.419 5.419 0 0 1-5.416-5.417v-5.416a5.419 5.419 0 0 1 5.416-5.417h5.417a5.419 5.419 0 0 1 5.417 5.417v5.416A5.419 5.419 0 0 1 107.5 42.5Zm5.417 57.969c0 5.157-1.154 21.575-14.847 27.815-1.355.617-2.936.514-4.29-.098l-8.347-3.781c-2-.904-2.097-3.612-.25-4.788 7.909-5.021 11.484-12.204 11.484-19.148V58.75a5.419 5.419 0 0 1 5.416-5.417h5.417a5.419 5.419 0 0 1 5.417 5.417v41.719ZM69.583 31.667v22.528c-1.88-.764-5.936-.862-7.935-.862-15.037 0-28.952 7.075-28.952 27.084 0 23.941 18.85 27.083 31.47 27.083 3.809 0 11.294-.287 17.025-1.121a5.419 5.419 0 0 0 4.642-5.368V31.667a5.419 5.419 0 0 0-5.416-5.417H75a5.419 5.419 0 0 0-5.417 5.417Zm-5.579 62.47c-7.096 0-13.975-2.237-13.975-13.72 0-11.484 6.88-13.271 13.975-13.271 1.733 0 3.683.325 5.58.758V93.38c-1.897.433-3.847.758-5.58.758Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjango);
export default __webpack_public_path__ + "static/media/django.545c71335c56fd4215ae38b17a024e89.svg";
export { ForwardRef as ReactComponent };